// 空间错误码
const spaceErrorCodeMap = {
  'space.not.exists': '空间不存在'
}

// 非空间成员错误码
const spaceNotErrorCodeMap = {
  'space.member.not.exists': '非空间成员'
}

// 成员列表接口错误码
export const listErrorCodeMap = { ...spaceErrorCodeMap }

// 移除成员接口错误码
export const removeErrorCodeMap = {
  ...spaceErrorCodeMap,
  ...spaceNotErrorCodeMap
}

// 修改权限接口错误码
export const modifyErrorCodeMap = {
  ...spaceErrorCodeMap,
  ...spaceNotErrorCodeMap
}

// 生成邀请链接接口错误码
export const getInvitationLinkErrorCodeMap = {
  ...spaceErrorCodeMap
}

// 通过邀请链接加入团队空间接口错误码
export const joinTeamSpacesErrorCodeMap = {
  ...spaceErrorCodeMap,
  'space.member.has.existed': '空间成员已存在'
}
